import axios from 'axios'
import { API_BASE } from '../constants/inviteCode'
import { deleteLeadsForDomain } from './leads'

export const deleteAuthority = async (token, authorityId) => {
  await axios.delete(`${API_BASE}/authorities/${authorityId}`, {
    headers: { Authorization: `Bearer ${token}` },
  })
}

export const deleteAuthorityWithLeads = async ({
  token,
  authorityId,
  domain,
  name,
}) => {
  const cityName = name || 'this city'
  const { deleted: leadsDeleted, cancelled } = await deleteLeadsForDomain(
    token,
    domain
  )
  if (cancelled) {
    return { deleted: false, cancelled: true }
  }

  if (leadsDeleted === 0) {
    if (!window.confirm(`Delete ${cityName}? This cannot be undone.`)) {
      return { deleted: false, cancelled: true }
    }
  }

  await deleteAuthority(token, authorityId)
  return { deleted: true, cancelled: false }
}
